module.exports = require('./PaymentInvoiceView');
